module.exports = require('./PaymentInvoiceView');
